import { useEffect, useState } from 'react';
import { getSiteSettings } from '@/lib/api';

const DEFAULT = {
  site_title: 'Smart Office Hub',
  site_description: 'Akıllı Ofis Otomasyon Sistemi',
  favicon_url: '/favicon.ico',
  theme_color: '#2563EB',
  logo_url: '',
};

const useSiteSettings = () => {
  const [settings, setSettings] = useState(DEFAULT);

  useEffect(() => {
    getSiteSettings()
      .then(r => {
        const s = r.data;
        setSettings(s);
        applyToDOM(s);
      })
      .catch(() => applyToDOM(DEFAULT));
  }, []);

  return settings;
};

export const applyToDOM = (s) => {
  // Title
  if (s.site_title) document.title = s.site_title;

  // Meta description
  let metaDesc = document.querySelector('meta[name="description"]');
  if (!metaDesc) { metaDesc = document.createElement('meta'); metaDesc.name = 'description'; document.head.appendChild(metaDesc); }
  metaDesc.content = s.site_description || '';

  // Theme color
  let metaTheme = document.querySelector('meta[name="theme-color"]');
  if (metaTheme) metaTheme.content = s.theme_color || '#2563EB';

  // Favicon
  if (s.favicon_url) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
    link.href = s.favicon_url;
  }
};

export default useSiteSettings;
